import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getContinentList(params) {
  return request({
    url: URL.mdm.basicData.continent,
    method: 'get',
    params
  })
}

export function addContinent(data) {
  return request({
    url: URL.mdm.basicData.continent,
    method: 'post',
    data
  })
}
